import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhone, FaWhatsapp } from "react-icons/fa";

export default function AgentDetails() {
    const { id } = useParams();
    const initialData = window.__INITIAL_DATA__ || null;
    const [agent, setAgent] = useState(initialData);
    const [loading, setLoading] = useState(!initialData);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!initialData) {
            fetch(`https://api-sumer.com/api/agents/${id}`)
                .then((res) => res.json())
                .then((data) => {
                    setAgent(data.data);
                    setLoading(false);
                })
                .catch(() => {
                    setError("Failed to fetch agent data");
                    setLoading(false);
                });
        }
    }, [id, initialData]);

    if (loading) return <p className="text-center text-gray-500 text-lg">Loading...</p>;
    if (error) return <p className="text-center text-red-500 text-lg">{error}</p>;

    return (
        <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-6 pt-20">
            <Helmet>
                <title>{agent.name}</title>
            </Helmet>

            {agent.image && (
                <img
                    src={agent.image}
                    alt={agent.name}
                    className="w-32 h-32 object-cover rounded-full mx-auto mb-4 shadow-md"
                />
            )}

            <h1 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">{agent.name}</h1>

            <div className="mt-6 p-4 bg-gray-100 rounded-lg shadow-sm grid grid-cols-1 gap-4">
                {agent.phone && (
                    <p className="font-semibold text-lg">Phone: <span className="text-blue-600">{agent.phone}</span></p>
                )}
                {agent.address && (
                    <p className="font-semibold text-lg">Address: <span className="text-gray-800">{agent.address}</span></p>
                )}

            </div>

            <div className="mt-6 flex flex-col items-center gap-4">
                {agent.phone && (
                    <div className="flex gap-4">
                        <a
                            href={`tel:${agent.phone}`}
                            className="bg-green-600 text-white px-6 py-3 rounded-full shadow-md text-lg font-semibold flex items-center gap-2 transition-transform transform hover:scale-105"
                        >
                            <FaPhone /> Call
                        </a>
                        <a
                            href={`https://wa.me/${agent.phone}`}
                            className="bg-green-500 text-white px-6 py-3 rounded-full shadow-md text-lg font-semibold flex items-center gap-2 transition-transform transform hover:scale-105"
                        >
                            <FaWhatsapp /> WhatsApp
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}